import React, { useEffect, useState } from "react";
import qs from "qs";
import { useNavigate, Link } from "react-router-dom";
import { URL } from "../../../constants/URL";
import CS from "../../../services/commonService";
import BreadCrumbs from "../../common/breadcrumbs";
import SearchBox from "../../common/searchBox";
import Table from "../../common/table";
import {
	useGetAllUsers,
	useDeleteUser,
	useBlockUser,
	useUnblockUser,
	useDownloadUsers,
} from "../../../queryHooks";
import Icon from "../../icons/index";
import ReactTooltip from "react-tooltip";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import SingleStatusToggle from "../../common/singleStatusToggle";
import { useStore } from "../../../zustand/store";
import { saveAs } from "file-saver";
import { modules } from "../../../constants/Modules";
import Modal from "../../common/Modal";
import InputModal from "../../common/InputModal";
import { pageToLoadOnDelete } from "../../../helpers";
//	Pre-defined values
const columnKey = "users";
//	Component starts
const OnboardedUsers = () => {
	const setLoading = useStore((state) => state.setLoading);
	const lastPageData = useStore((state) => state.lastPageData);
	const setLastPageData = useStore((state) => state.setLastPageData);
	//  Navigation
	const navigate = useNavigate();
	//	State values
	const [openModal, setOpenModal] = useState(false);
	const [user, setUser] = useState();
	const [tableData, setTableData] = useState();
	const [pageNow, setPageNow] = useState(
		lastPageData?.[modules.USERS]?.page || 1
	);
	const [itemsPerPage, setItemsPerPage] = useState(
		lastPageData?.[modules.USERS]?.items_per_page || 10
	);
	const [usersPayload, setUsersPayload] = useState(
		lastPageData?.[modules.USERS] || {
			pagination: true,
			items_per_page: itemsPerPage,
			page: pageNow,
			sort: { created_at: "DESC" },
		}
	);

	/******************************************************************************************
	@Purpose    :   To get the users list
	*******************************************************************************************/

	const {
		data: dataGetAllUsers,
		isLoading,
		refetch,
	} = useGetAllUsers(qs.stringify(usersPayload));

	useEffect(() => {
		if (dataGetAllUsers && dataGetAllUsers.status === "success") {
			let respData = dataGetAllUsers.data;
			respData.page = pageNow;
			respData.items_per_page = itemsPerPage;
			setTableData(respData);
		}
	}, [dataGetAllUsers]);

	const {
		mutateAsync: blockUser,
		error: errorBlockUser,
		data: dataBlockUser,
	} = useBlockUser();

	useEffect(() => {
		if (dataBlockUser) {
			setLoading(false);
			if (dataBlockUser.status === "success") {
				CS.showSuccessMessage(dataBlockUser.message);
				refetch();
			} else if (dataBlockUser.status === "fail") {
				CS.showErrorMessage(dataBlockUser.message);
			}
		}
	}, [dataBlockUser]);

	useEffect(() => {
		if (errorBlockUser) {
			setLoading(false);
			CS.showErrorMessage(errorBlockUser.response?.data?.message);
		}
	}, [errorBlockUser]);

	const {
		mutateAsync: unblockUser,
		error: errorUnblockUser,
		data: dataUnblockUser,
	} = useUnblockUser();

	useEffect(() => {
		if (dataUnblockUser) {
			setLoading(false);
			if (dataUnblockUser.status === "success") {
				CS.showSuccessMessage(dataUnblockUser.message);
				refetch();
			} else if (dataUnblockUser.status === "fail") {
				CS.showErrorMessage(dataUnblockUser.message);
			}
		}
	}, [dataUnblockUser]);

	useEffect(() => {
		if (errorUnblockUser) {
			setLoading(false);
			CS.showErrorMessage(errorUnblockUser.response?.data?.message);
		}
	}, [errorUnblockUser]);

	const {
		mutateAsync: deleteUser,
		error: errorDeleteUser,
		data: dataDeleteUser,
	} = useDeleteUser();

	useEffect(() => {
		if (dataDeleteUser) {
			setLoading(false);
			if (dataDeleteUser?.status === "success") {
				setOpenModal(false);
				setUser();
				let _page = pageToLoadOnDelete(
					tableData?.total_items,
					1,
					pageNow,
					itemsPerPage
				);
				setPageNow(_page);
				setUsersPayload({ ...usersPayload, page: _page });
				CS.showSuccessMessage(dataDeleteUser?.message);
				refetch();
			} else if (dataDeleteUser?.status === "fail") {
				CS.showErrorMessage(dataDeleteUser?.message);
			}
		}
	}, [dataDeleteUser]);

	useEffect(() => {
		if (errorDeleteUser) {
			setLoading(false);
			CS.showErrorMessage(errorDeleteUser?.response?.data?.message);
		}
	}, [errorDeleteUser]);

	const {
		mutateAsync: downloadUsers,
		data: dataDownloadUsers,
		isLoading: isLoadingDownload,
	} = useDownloadUsers(usersPayload);

	useEffect(() => {
		if (dataDownloadUsers) {
			saveAs(dataDownloadUsers?.data?.filePath, "users.xlsx");
		}
	}, [dataDownloadUsers]);

	const columns = [
		{
			label: "Joined Date",
			type: "date",
			sort: true,
			path: "created_at",
			alias: "created_at",
			filterDate: true,
			content: (item) => getCurrentTimezoneDate(item.created_at),
		},
		{
			label: "Name",
			type: "string",
			path: "name",
			alias: "first_name",
			sort: true,
			content: (item) => (
				<Link
					to={`${URL.onboarderedUsers}/${item?.id}`}
					onClick={() => {
						setLastPageData({ [modules.USERS]: usersPayload });
					}}
				>
					<div className="d-flex align-items-center">
						<div className="flex-auto">
							{CS.renderImageUrl(item.profile_image_url)}
						</div>
						<div className="d-flex flex-column flex-wrap">
							<span className="pl-2">
								{item.first_name} {item.last_name}
							</span>
						</div>
					</div>
				</Link>
			),
		},
		{
			label: "Email",
			type: "string",
			// sort: true,
			path: "email",
			// alias: "email",
			content: (item) => (
				<div className="email-col d-flex align-items-center">
					{/* <div className="badge-outer circle round d-flex align-items-center mr-2">
						<span
							className={
								item?.is_email_verified === 1
									? "badge badge-success circle"
									: "badge badge-danger circle"
							}
						></span>
					</div> */}
					<span>{item.email}</span>
				</div>
			),
		},
		{
			label: "Phone No",
			type: "string",
			// sort: true,
			path: "mobile",
			// alias: "mobile",
		},
		{
			label: "Status",
			type: "boolean",
			aliasFilter: "is_active",
			filterOptions: [
				{ value: 1, label: "Unblocked" },
				{ value: 0, label: "Blocked" },
			],
			content: (item) => (
				<SingleStatusToggle
					_id={item.id}
					status={item.is_active == 1 ? true : false}
					onToggleChange={() => {
						if (item.is_active == 1) {
							blockUser(item.id);
							setLoading(true);
						} else {
							unblockUser(item.id);
							setLoading(true);
						}
					}}
					htmlFor={item.id}
				/>
			),
		},
		{
			label: "Action",
			type: "boolean",
			content: (item) => (
				<>
					<Icon
						type="show"
						data-tip
						data-for="show"
						onClick={() => {
							setLastPageData({ [modules.USERS]: usersPayload });
							navigate(`${URL.onboarderedUsers}/${item?.id}`);
						}}
					/>
					<ReactTooltip id="show" place="top" effect="solid">
						Show
					</ReactTooltip>
					<Icon
						type="delete"
						data-tip
						data-for="delete"
						onClick={() => {
							setUser(item);
							setOpenModal(true);
						}}
						// onClick={() =>
						// 	swal
						// 		.fire({
						// 			title: "Are you sure, you want to delete this user?",
						// 			text: `You won't be able to revert this!`,
						// 			icon: "warning",
						// 			showCancelButton: true,
						// 			confirmButtonColor: "#3085d6",
						// 			cancelButtonColor: "#d33",
						// 			confirmButtonText: "Yes, delete it!",
						// 		})
						// 		.then((result) => {
						// 			if (result.isConfirmed) {
						// 				deleteUser(item.id);
						// 				setLoading(true);
						// 			}
						// 		})
						// }
					/>
					<ReactTooltip id="delete" place="top" effect="solid">
						Delete
					</ReactTooltip>
				</>
			),
		},
	];

	const handleUserDelete = () => {
		if (user?.id) deleteUser(user?.id);
	};

	const closeModalHandler = () => {
		setUser();
		setOpenModal(false);
	};

	const modalDescriptions = [
		"- This action is irreversible i.e, once you delete user you will not be able to recover this user.",
		"- This will remove all the data of this user from our platform.",
		"- Gifts sended by this user would still be available for redemption.",
	];

	const UserDetails = ({ user }) => {
		return (
			<div className="row mb-2">
				<div className="col-md-6">
					<p>
						Name:{" "}
						<strong>
							{user?.first_name} {user?.last_name}
						</strong>
					</p>
				</div>
				<div className="col-md-6">
					<p>
						Username: <strong>{user?.username}</strong>
					</p>
				</div>
			</div>
		);
	};

	return (
		<>
			{/* <BreadCrumbs title="Users Management" data={[{ label: "Users" }]} />
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid"> */}
			<div className="grid-content">
				<div className="user-listing-filterOptions mb-2 d-block">
					<div className="row mb-2">
						<div className="col-sm-8 mb-2 position-static">
							<div className="left-buttons d-flex">
								<SearchBox
									columnKey={columnKey}
									searchValue={lastPageData?.[modules.USERS]?.search?.username}
									search={(value) => {
										setPageNow(1);
										setUsersPayload({
											...usersPayload,
											search: {
												username: !value && value === "" ? undefined : value,
												mobile: !value && value === "" ? undefined : value,
												email: !value && value === "" ? undefined : value,
												first_name: !value && value === "" ? undefined : value,
												last_name: !value && value === "" ? undefined : value,
											},
											page: 1,
										});
									}}
								/>
							</div>
						</div>
						<div className="col-sm-4">
							<div className="right-buttons d-flex justify-content-end">
								<button
									className="btn btn-default minW-md-0 btn-bg-white"
									onClick={() =>
										downloadUsers({
											...usersPayload,
											timeZone: CS.getTimezone(),
										})
									}
								>
									{isLoadingDownload ? "Downloading..." : "Download"}
								</button>
							</div>
						</div>
					</div>
				</div>
				<Table
					columnKey={columnKey}
					columns={columns}
					tableData={tableData}
					payload={usersPayload}
					sortCol={(obj) => {
						setPageNow(1);
						setUsersPayload({
							...usersPayload,
							sort: {
								[obj.alias]:
									!obj.sort && obj.sort === "" ? undefined : obj.sort,
							},
							page: 1,
						});
					}}
					setCurrentPage={(page) => {
						setPageNow(page);
						setUsersPayload({
							...usersPayload,
							page,
						});
					}}
					setCurrentLimit={(items_per_page) => {
						setPageNow(1);
						setItemsPerPage(items_per_page);
						setUsersPayload({
							...usersPayload,
							items_per_page,
							page: 1,
						});
					}}
					loading={isLoading}
					filterValue={async (obj) => {
						if (obj.filter === null) {
							const resp = await CS.filterData(usersPayload.filter, obj);
							setPageNow(1);
							setUsersPayload({
								...usersPayload,
								filter: resp,
								page: 1,
							});
						} else {
							setPageNow(1);
							setUsersPayload({
								...usersPayload,
								filter: {
									...usersPayload.filter,
									[obj.alias]: obj.filter,
								},
								page: 1,
							});
						}
					}}
					filterDate={(dates) => {
						setPageNow(1);
						setUsersPayload({
							...usersPayload,
							filter_date: dates && {
								[dates.alias]: String(dates.filter),
							},
							page: 1,
						});
					}}
				/>
			</div>
			<Modal open={openModal} onCloseModal={closeModalHandler}>
				<InputModal
					title={
						"Are you sure you want to permanently delete this user account ?"
					}
					detailsComponent={<UserDetails user={user} />}
					descriptions={modalDescriptions}
					onCloseModal={closeModalHandler}
					successHandler={handleUserDelete}
				/>
			</Modal>
			{/* </div>
				</div>
			</div> */}
		</>
	);
};

export default OnboardedUsers;
